// components/EmbudoManager.js
import React, { useState } from 'react';
import {
  FormGroup, Input, Label, Button
} from 'reactstrap';
import {
  PlusCircle, Trash2, Flag
} from 'lucide-react';
import { postPipelineCreate } from '../../../helpers/backend';
import './styles/Typifications.css';

const EmbudoManager = ({ campaign, onSaved }) => {
  const [newPipeline, setNewPipeline] = useState({
    name: '', description: '', stages: []
  });
  const [newStage, setNewStage] = useState({
    name: '', description: '', is_final: false
  });
  const [isSaving, setIsSaving] = useState(false);

  const handleAddStage = () => {
    if (!newStage.name.trim()) return;
    
    const nextOrder = newPipeline.stages.length > 0 
      ? Math.max(...newPipeline.stages.map(s => s.order)) + 1 
      : 1;
    
    setNewPipeline(prev => ({
      ...prev,
      stages: [...prev.stages, { ...newStage, order: nextOrder }]
    }));
    setNewStage({ name: '', description: '', is_final: false });
  };

  const handleRemoveStage = (index) => {
    const updated = [...newPipeline.stages];
    updated.splice(index, 1);
    
    // Reasignar órdenes después de eliminar
    const stagesWithCorrectOrder = updated.map((stage, idx) => ({
      ...stage,
      order: idx + 1
    }));
    
    setNewPipeline(prev => ({ ...prev, stages: stagesWithCorrectOrder }));
  };

  const handleCreatePipeline = async () => {
    if (!newPipeline.name || newPipeline.stages.length === 0) return;
    try {
      setIsSaving(true);
      await postPipelineCreate({
        name: newPipeline.name,
        description: newPipeline.description,
        campaign_id: campaign.id,
        stages: newPipeline.stages.map(s => ({
          name: s.name,
          description: s.description,
          order: s.order,
          is_final: s.is_final
        }))
      });
      setNewPipeline({ name: '', description: '', stages: [] });
      onSaved?.();
    } catch (err) {
      alert('Error creando el embudo');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div>
      <h5 className="section-title mb-3">Embudo</h5>

      {campaign.pipeline ? (
        <>
          <div className="pipeline-head mb-3">
            <strong>{campaign.pipeline.name}</strong>
            <div className="text-muted">{campaign.pipeline.description}</div>
          </div>

          <div className="stage-card-grid">
            {campaign.pipeline.stages.map(stage => (
              <div key={stage.id} className="stage-card">
                <div className="stage-header">
                  <span className="stage-order">{stage.order}.</span>
                  <span className="stage-name">{stage.name}</span>
                </div>
                {stage.is_final && (
                  <div className="final-badge">
                    <Flag size={14} className="me-1" />
                    Etapa Final
                  </div>
                )}
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          <FormGroup>
            <Label>Nombre del embudo</Label>
            <Input
              value={newPipeline.name}
              onChange={(e) => setNewPipeline({ ...newPipeline, name: e.target.value })}
            />
          </FormGroup>
          <FormGroup>
            <Label>Descripción</Label>
            <Input
              value={newPipeline.description}
              onChange={(e) => setNewPipeline({ ...newPipeline, description: e.target.value })}
            />
          </FormGroup>

          <hr />
          <h6>Agregar Etapas</h6>
          <FormGroup>
            <Input
              placeholder="Nombre de la etapa"
              value={newStage.name}
              onChange={(e) => setNewStage({ ...newStage, name: e.target.value })}
              className="mb-2"
            />
            <Input
              placeholder="Descripción"
              value={newStage.description}
              onChange={(e) => setNewStage({ ...newStage, description: e.target.value })}
              className="mb-2"
            />
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                checked={newStage.is_final}
                onChange={(e) => setNewStage({ ...newStage, is_final: e.target.checked })}
              />
              <label className="form-check-label">Es etapa final</label>
            </div>
            <Button color="primary" className="mt-2" onClick={handleAddStage}>
              <PlusCircle size={16} className="me-1" /> Agregar etapa
            </Button>
          </FormGroup>

          <div className="mt-3">
            <h6>Etapas agregadas:</h6>
            {newPipeline.stages.map((s, i) => (
              <div key={i} className="stage-card editable-card d-flex justify-content-between align-items-center">
                <div>
                  <strong>{s.order}.</strong> {s.name}
                  {s.is_final && (
                    <div className="final-badge ms-2">Etapa Final</div>
                  )}
                </div>
                <Button color="danger" size="sm" onClick={() => handleRemoveStage(i)}>
                  <Trash2 size={14} />
                </Button>
              </div>
            ))}
          </div>

          <Button color="success" className="mt-3" onClick={handleCreatePipeline} disabled={isSaving}>
            {isSaving ? 'Guardando...' : 'Crear embudo'}
          </Button>
        </>
      )}
    </div>
  );
};

export default EmbudoManager;